import { DataResponse } from "services/response";
import { BASE_API_URL } from "utils/constants";
import { deleted, downloadFilePost, downloadFilePostNew, get, post } from '../../utils/api';
import { DetailContactSegment } from "./customerSegment_services";

// ================================== Contact SEGMENTS =================================
export interface ContactSegmentModel {
  id: string;
  stt: number
  contactSegmentationCode: number
  contactSegmentationName: string
  contactNumber: number
  status: boolean
  createBy: string
  createTime: string
}

// ==================================================================================================
export type DetailsContactSegmentModel = Partial<{
  stt: number
  profileId: string,
  contactId: string,
  crmCode: string,
  customerName: string,
  customerCode: string,
  profileName: string,
  phone: string,
  email: string,
  branch: string,
  description: string,
  createBy: string,
  createTime: string,
  status: boolean,
  csdb: boolean

  actived: boolean
}>

// ================================== ACTIVITIES OF CONTACT SEGMENT =================================
export interface ActivitiesOfContactSegment {
  stt: number
  crmCode: string
  title: string
  type: string
  status: string
  createTime: string
  contactCode: string
  contactName: string
  email: string
  contact: string
}


// ============ Khai báo phương thức =====================
export interface IContactSegmentServices {
  //   Lấy danh sách Contact Segment
  getlistContactSegments(data: object): Promise<DataResponse<Array<ContactSegmentModel>>>
  // danh sách hoạt động của Contact segment theo type
  getActivitiesOfContactSegment(data: object): Promise<DataResponse<Array<ActivitiesOfContactSegment>>>
  // tạo contact segment
  createContactSegment(data: object): Promise<DataResponse<null>>
  // Danh sách khách hàng của contact segment
  getCustomerOfContactSegment(data: object): Promise<DataResponse<DetailContactSegment>>

  // edit contact segment
  editContactSegment(data: object): Promise<DataResponse<null>>


  // delete contact segment
  deleteContactSegment(id: string): Promise<DataResponse<null>>

  // export excel
  exportExcel(data: object): Promise<void>


  // lấy danh sách theo id (mảng)
  getContact(profileIds: string): Promise<DataResponse<Array<DetailsContactSegmentModel>>>

  // tạo mới contact segment

}
// Hàm khởi tạo các phương thức của  service
export function createContactSegmentServices(): IContactSegmentServices {
  return {
    //   Lấy danh sách Contact Segment
    getlistContactSegments: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Segmentation/list-contact-segmentation`, data))
        .data;
    },
    // danh sách hoạt động của Contact segment theo type
    getActivitiesOfContactSegment: async (data) => {
      return (await post(BASE_API_URL, 'Segmentation/activities-of-contact-segment', data)).data
    },
    // Tạo mới contact segment
    createContactSegment: async (data) => {
      return (await post(BASE_API_URL, 'Segmentation/create-contact-segment', data)).data
    },
    // Danh sách khách hàng của contact segment
    getCustomerOfContactSegment: async (data) => {
      return (await post(BASE_API_URL, 'Segmentation/customer-of-contact-segment', data)).data
    },
    // cập nhật contact segment
    editContactSegment: async (data) => {
      return (await post(BASE_API_URL, 'Segmentation/edit-contact-segmentation', data)).data
    },
    // delete contact segment
    deleteContactSegment: async (id) => {
      return (await get(BASE_API_URL, 'Segmentation/delete-contact-segmentation', {
        id: id
      })).data
    },

    // export excel
    exportExcel: async (data) => {
      return (await downloadFilePostNew(BASE_API_URL, `Segmentation/export-excel-kh-by-contactsegment`, data))
    },

    // lấy danh sách theo id (mảng)
    getContact: async (profileIds) => {
      return (await post(BASE_API_URL, `Segmentation/gets-contact`, {
        profileIds: profileIds
      })).data
    },
  };
}
